import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {useSelector} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import {ALL_COUNTRIES} from 'front-onceforall-core/dist/utils/country';
import CountryFlag from '../countryFlag';

function CountrySelectorView(props) {
  const currentLocale = useSelector(state => state.i18n.locale);
  const menuItems = props.countriesToShow
    .sort((country, previousCountry) => I18n.t(`country.${country}`).localeCompare(I18n.t(`country.${previousCountry}`), currentLocale, {ignorePunctuation: true}))
    .map(country => (
      <MenuItem
        key={country}
        value={country}
      >
        <CountryFlag
          country={country}
          size={16}
        />
      </MenuItem>
    ));
  return (
    <TextField
      name="countrySelect"
      id="countrySelect"
      select
      disabled={props.disabledCountrySelector}
      value={props.value}
      onChange={props.onChange}
    >
      {menuItems}
    </TextField>
  );
}

CountrySelectorView.defaultProps = {
  countriesToShow: ALL_COUNTRIES
};

CountrySelectorView.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabledCountrySelector: PropTypes.bool,
  countriesToShow: PropTypes.array
};

export default CountrySelectorView;
